import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * /app/home/course/:grpId — a link to one course, used by Elliott's course
 * recommendations (in the chat and in Teams). Hands off to the member
 * dashboard, which opens that course's drawer once the learner's programs load.
 */
const CourseDeepLink: React.FC = () => {
  const { grpId } = useParams();
  return <Navigate to="/app/home/user" replace state={grpId ? { openProgramId: grpId } : null} />;
};

export default CourseDeepLink;
